module.exports = __webpack_public_path__ + "img/10.fc81b1d.svg";